import { render, staticRenderFns } from "./SectionDividerView.vue?vue&type=template&id=35a56db6&scoped=true"
import script from "./SectionDividerView.vue?vue&type=script&lang=js"
export * from "./SectionDividerView.vue?vue&type=script&lang=js"
import style0 from "./SectionDividerView.vue?vue&type=style&index=0&id=35a56db6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a56db6",
  null
  
)

export default component.exports